import { AbsStoreWorkProcess, } from './AbsStoreWorkProcess';
export class StoreWorkProcessCommentPost extends AbsStoreWorkProcess {
    createReqBody() {
        const data = {
            parentId: this.reqBody.id,
            title: this.reqBody.title,
            body: this.reqBody.body,
            isImportant: this.reqBody.isImportant,
        };
        return data;
    }
}
